import { SendAsOptions } from './report-send-as-options';

export class TriggerEntity {
    constructor(source?: Partial<TriggerEntity>) {
        if (source) {
            Object.assign(this, source);
        }
    }

    Id = 0;
    Weekdays = ''; // Comma-separated values like: 'Monday,Thursday,Saturday'
    StartTime = '';
    EndTime = '';
    TimeZoneIdentifier = '';
}

export class ScheduledItemEntity {
    constructor(source?: Partial<ScheduledItemEntity>) {
        if (source) {
            Object.assign(this, source);
            if (source.StartDate) {
                this.StartDate = new Date(source.StartDate);
            }
            if (source.EndDate) {
                this.EndDate = new Date(source.EndDate);
            }
            if (source.Enabled) {
                this.Enabled = Boolean(source.Enabled);
            }
        }
    }

    Id = 0;
    StartDate: Date = null;
    EndDate: Date = null;
    Enabled = false;
}

export class ReportParameterEntity {
    constructor(source?: Partial<ReportParameterEntity>) {
        if (source) {
            Object.assign(this, source);
        }
    }

    Id = 0;
    ReportsId = 0;
    Name = '';
    DisplayName = '';
    Type = '';
    DefaultValue = '';
}

export class ReportEntity {
    constructor(source?: Partial<ReportEntity>) {
        if (source) {
            Object.assign(this, source);
        }
    }

    Id = 0;
    Name = '';
    Description = '';
    Script = '';
    IsSystem = false;
    SendTo = '';
    SendAs: string = null;
    ScheduleItemsId?= 0;
    CreatedDate: Date;
    CreatedBy: number;
    UpdatedDate: Date;
    UpdatedBy: number;
}

export class ReportConfiguration {
    constructor(source?: Partial<ReportConfiguration>) {
        if (source) {
            Object.assign(this, source);
            if (source.Report) {
                this.Report = new ReportEntity(source.Report);
            }
            if (source.ReportParameters?.length > 0) {
                this.ReportParameters = source.ReportParameters.map(e => new ReportParameterEntity(e));
            }
            if (source.ScheduledItem) {
                this.ScheduledItem = new ScheduledItemEntity(source.ScheduledItem);
            }
            if (source.Triggers?.length > 0) {
                this.Triggers = source.Triggers.map(e => new TriggerEntity(e));
            }
        }
    }

    Report: ReportEntity = new ReportEntity();
    ReportParameters: ReportParameterEntity[] = [];
    ScheduledItem?: ScheduledItemEntity = null;
    Triggers: TriggerEntity[] = [];
}
